import React from "react";
import { useEffect, useState } from "react";
import Helmet from "react-helmet";
import { withTranslation } from "react-i18next";
import LoginService from "../../../service/Auth/Login";
import Spinner from "../../shared/Spinner";
import { withRouter } from "react-router";
import companyName from "../../../store/mobxStore/companyName";
import "./style.css"

const PrivacyPolicy = (props) => {
  const [data, setData] = useState("");
  const service = new LoginService();
  const { t } = props;

  useEffect(() => {
    const fetchData = async () => {
      const privacyData = await service.getPrivacyPolicy();
      console.log({ privacyData });
      if (privacyData.status) {
        setData(privacyData.data.message);
      }
    };
    fetchData();
  }, []);

  return (
    <div>
      <React.Suspense fallback={<Spinner />}>
        <Helmet>
          <title>
            {companyName.companyName} | {t("Sidemenu.overview")}
          </title>
        </Helmet>
        {data ? (
          <div
            className="privacy-policy-content"
            dangerouslySetInnerHTML={{ __html: data }}
          />
        ) : (
          <Spinner />
        )}
      </React.Suspense>
    </div>
  );
};
export default withTranslation()(withRouter(PrivacyPolicy));
